import type React from 'react';
import Modal from '@common/components/Modal';
import userPersonas from '@common/constants/userPersonas';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';
import './index.scss';
import ContentBox3 from '@zg-rentals/multibrand-ui/lib/ContentBox3';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Bell from '@zg-rentals/multibrand-ui/lib/icons/Bell';
import BluePrintIcon from '@assets/Blueprint.svg';
import PaymentPlanIcon from '@assets/payment-plan.svg';
import RPIcon from '@assets/rental-protection.svg';
import StringConstants from '@common/constants/StringConstants';

type Props = {
  onClose: () => void;
  goToSetupPaymentPlan: () => void;
};

const HandleMissedRent: React.FC<React.PropsWithChildren<Props>> = (props: Props): JSX.Element => {
  return (
    <Modal
      persona={userPersonas.LANDLORD}
      header="Handling missed rent"
      onRequestClose={props.onClose}
      dataAutoTestId="landlord-handle-missed-rent"
    >
      <Row>
        <Col className="txtC">
          <img src={BluePrintIcon as unknown as string} alt="" className="bluePrintIcon" />
          <Text type="h4" className="zillowInsuranceSubHeading" emphasize>
            Zillow Insurance Services
          </Text>
          <Text type="h3">How to handle missed rent</Text>
        </Col>
      </Row>
      <Row>
        <Col>
          <Text>
            First, talk to your tenant to find out what&apos;s going on. If they aren&apos;t going to pay the past due
            rent soon, you&apos;ll need to choose one of these options if you plan to file a Rental Protection claim.
          </Text>
        </Col>
      </Row>
      <Row>
        <Col>
          <Bell colorType="action" size="md" className="bell-icon-alignment" />
          <Text inline>
            If you don&apos;t act within 30 days of the missed rent&apos;s due date, your Rental Protection coverage may
            be affected.
          </Text>
        </Col>
      </Row>
      <SpacerRow size="sm" />
      <ContentBox3>
        <Row>
          <Col md={2}>
            <img src={PaymentPlanIcon as unknown as string} alt="" />
          </Col>
          <Col md={10}>
            <Text inline type="body-small" className="boldText">
              Allow your tenant to catch up
            </Text>
            <Text type="body-small">
              If your tenant is having a tough time, you can allow them to pay back the past due rent through a payment
              plan.
            </Text>
            <SpacerRow size="sm" />
            <Text>
              <Link onClick={props.goToSetupPaymentPlan}>See how to set up a payment plan</Link>
            </Text>
          </Col>
        </Row>
      </ContentBox3>
      <SpacerRow />
      <ContentBox3>
        <Row>
          <Col md={2}>
            <img src={RPIcon as unknown as string} alt="" />
          </Col>
          <Col md={10}>
            <Text inline type="body-small" className="boldText">
              Take steps to remove the tenant
            </Text>
            <Text type="body-small">
              If your tenant is breaking their lease, you may need to begin the process of repossessing the property.
            </Text>
            <SpacerRow size="sm" />
            <Text>
              <Link href={StringConstants.LINKS.PREPARE_FOR_MISSED_RENT_CLAIM.LANDLORD} target="_blank">
                See how to prepare for a missed rent claim
              </Link>
            </Text>
          </Col>
        </Row>
      </ContentBox3>
    </Modal>
  );
};

export default HandleMissedRent;
